import type { LogoWallContent } from "../types";

export const logoWall: LogoWallContent = {
  title: "Built by the universities.",
  introLead:
    "Developed by the University of Southern Denmark, UCloud AI is " +
    "integrated into the national research platform UCloud. The service " +
    "builds on the existing collaboration between SDU, Aarhus University " +
    "and Aalborg University in the DeiC Interactive HPC consortium, and " +
    "runs on Bitten in a sustainable datacenter in Sønderborg, built by " +
    "SDU in partnership with Danfoss and HPE. ",
  introStrong:
    "Europe's most-used national research cloud, now with sovereign AI " +
    "inference built in.",
  linkLabel: "Explore Interactive HPC",
  mapTitle: "Map of Denmark",
  mapDescription:
    "A map of Denmark showing the eight Danish universities and the Bitten datacenter in Sønderborg.",
  mapLabelPrimary: "DENMARK / EU",
  mapLabelSecondary: "8 UNIVERSITIES · 1 NATIONAL PLATFORM",
  nodeNames: {
    aalborg: "Aalborg University",
    aarhus: "Aarhus University",
    sdu: "University of Southern Denmark",
    ku: "University of Copenhagen · IT University of Copenhagen · Copenhagen Business School",
    dtu: "Technical University of Denmark",
    ruc: "Roskilde University",
    bitten: "Bitten datacenter, Sønderborg",
    gefion: "DCAI/Gefion",
  },
  logoAriaLabel: "Interactive HPC Consortium logos",
  logoNames: {
    aalborg: "Aalborg University",
    aarhus: "Aarhus University",
    sdu: "University of Southern Denmark",
  },
  logoHrefs: {
    aalborg: "https://www.en.aau.dk/",
    aarhus: "https://international.au.dk/",
    sdu: "https://www.sdu.dk/en",
  },
};
